import { FormEvent, useState } from 'react';

export interface PrescriptionValues {
  name: string;
  birthDate: string;
  email: string;
  phone: string;
  medication: string;
  pharmacy: string;
}

type Errors = Partial<Record<keyof PrescriptionValues, string>>;
type Status = 'idle' | 'submitting' | 'success';

const initialValues: PrescriptionValues = { name: '', birthDate: '', email: '', phone: '', medication: '', pharmacy: '' };

export function useRepeatPrescriptionForm() {
  const [values, setValues] = useState<PrescriptionValues>(initialValues);
  const [errors, setErrors] = useState<Errors>({});
  const [status, setStatus] = useState<Status>('idle');

  const update = (field: keyof PrescriptionValues, value: string) => {
    setValues((v) => ({ ...v, [field]: value }));
    if (errors[field]) setErrors((e) => ({ ...e, [field]: undefined }));
  };

  const submit = (event: FormEvent) => {
    event.preventDefault();
    const next: Errors = {};
    if (!values.name.trim()) next.name = 'Vul uw naam in.';
    if (!values.birthDate) next.birthDate = 'Vul uw geboortedatum in.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) next.email = 'Vul een geldig e-mailadres in.';
    if (!values.medication.trim()) next.medication = 'Vermeld welke medicatie u nodig heeft.';
    if (!values.pharmacy.trim()) next.pharmacy = 'Vermeld uw apotheek.';
    setErrors(next);
    if (Object.keys(next).length > 0) return;
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };

  const reset = () => {
    setValues(initialValues);
    setErrors({});
    setStatus('idle');
  };

  return { values, errors, status, update, submit, reset };
}
